import PermissionRoute from '@Src/_basic/helpers/PermissionRoute';
import { RouteConfig } from '@Src/app/BasicRouter';
import React, { memo } from 'react';
import RoleMaintenanceScreen from './screens/RoleMaintenanceScreen';

const routesConfig: RouteConfig[] = [
  {
    path: '/',
    element: <RoleMaintenanceScreen />,
  },
];

const RoleMaintenanceRouter = () => PermissionRoute(routesConfig);

export default memo(RoleMaintenanceRouter);
